/**
 * Credit Payment Service (credit-payment-business)
 * API Gateway path: /credit-payment
 * Funding management endpoints
 */

import { apiGet, apiPost } from '@/lib/axios';
import type { FundingInstruction } from '@/types/funding.types';

// RBAC v2: /credit-payment/v2/backoffice/funding/* (W4 + @RequirePermission).
// Los 9 endpoints de funding tienen gemelo /v2 verificado en el openapi de credit-payment.
const BASE = '/credit-payment/v2';

// ─── Funding ─────────────────────────────────────────────────────────────────

/** List funding instructions pending confirmation */
export const getPendingFunding = () =>
  apiGet<FundingInstruction[]>(`${BASE}/backoffice/funding/pending`);

/** List funding instructions by partner and date (both required) */
export const getFundingByDate = (partnerId: string, date: string) =>
  apiGet<FundingInstruction[]>(`${BASE}/backoffice/funding`, { params: { partnerId, date } });

/** Get a single funding instruction detail */
export const getFundingDetail = (fundingId: string) =>
  apiGet<FundingInstruction>(`${BASE}/backoffice/funding/${fundingId}`);

/** Confirm a funding transfer */
export const confirmFunding = (fundingId: string, data: { bankReference: string; confirmedBy: string }) =>
  apiPost<void>(`${BASE}/backoffice/funding/${fundingId}/confirm`, data);

/** Get daily funding history (last N days) */
export const getFundingHistory = (days = 30) =>
  apiGet<any[]>(`${BASE}/backoffice/funding/history`, { params: { days } });

/** Get instructions sent by UNE-Credito, pending FiadoSA confirmation (status=SENT) */
export const getSentFunding = () =>
  apiGet<any[]>(`${BASE}/backoffice/funding/sent`);

/** Get credits pending funding (accumulated, not yet funded) */
export const getPendingCredits = (partnerId = 'UNE') =>
  apiGet<any>(`${BASE}/backoffice/funding/pending-credits`, { params: { partnerId } });

/** Create funding instruction (group pending credits) */
export const createFundingInstruction = (partnerId: string, creditIds?: string[]) =>
  apiPost<any>(`${BASE}/backoffice/funding/create`, { partnerId, creditIds });

/** UNE-Credito registers SPEI sent */
export const registerFundingSent = (fundingId: string, data: { bankReference: string; sentBy: string }) =>
  apiPost<any>(`${BASE}/backoffice/funding/${fundingId}/sent`, data);
